import { openDB } from 'idb';

// Stores IndexedDB du content pack. Une categorie = un store, meme nom que l'API.
// keyPath = PK de la table (composite pour content_texts).
export const CONTENT_STORES = Object.freeze({
  modes: 'id',
  progressions: 'id',
  moods: 'id',
  tiers: 'id',
  artists: 'id',
  packs: 'id',
  backings: 'id',
  lessons: 'id',
  videos: 'id',
  texts: ['entity_type', 'entity_id', 'field', 'locale'],
});

export const CONTENT_CATEGORIES = Object.freeze(Object.keys(CONTENT_STORES));

export const DB_NAME = 'upscale';
// v2 : ajout des stores de donnees user (sync engine, S0 subtask 6).
// v3 : store packs (packs de backing tracks). Cree vide a l'upgrade sur une base
// existante, rempli par le premier sync serveur.
// v4 : store lessons (lecons Guitar Pro du lesson player). Meme mecanique : cree vide
// a l'upgrade, rempli par le premier sync serveur.
export const DB_VERSION = 4;

// Schéma de la base : chaque store est créé s'il manque, jamais recréé.
const OPEN_OPTIONS = {
  upgrade(db) {
    for (const [store, keyPath] of Object.entries(CONTENT_STORES)) {
      if (!db.objectStoreNames.contains(store)) {
        db.createObjectStore(store, { keyPath });
      }
    }
    // Store cle/valeur libre : curseurs de sync par categorie, etc.
    if (!db.objectStoreNames.contains('meta')) {
      db.createObjectStore('meta');
    }
    // Donnees user (user_data). PK composite [scope, item_key], comme la table.
    // Chaque row porte data / deleted / updated_at / dirty (flag tenant lieu d'outbox).
    if (!db.objectStoreNames.contains('userData')) {
      db.createObjectStore('userData', { keyPath: ['scope', 'item_key'] });
    }
    // Curseurs de sync user : 'lastPull' (out-of-line keys).
    if (!db.objectStoreNames.contains('syncMeta')) {
      db.createObjectStore('syncMeta');
    }
  },
};

// Ouvre (et migre) la base content. IndexedDB est la source de verite de l'UI.
export async function openContentDb(name = DB_NAME) {
  try {
    return await openDB(name, DB_VERSION, OPEN_OPTIONS);
  } catch (err) {
    // La base est déjà dans une version plus récente : build TestFlight installé,
    // puis version du store par-dessus. Sans ce rattrapage l'app repart sans base
    // du tout, le voile de connexion ne se lève jamais et la déconnexion plante.
    // Une base plus récente contient tous les stores de l'ancienne : on la rouvre
    // telle quelle, sans imposer de numéro de version.
    if (err?.name !== 'VersionError') throw err;
    return openDB(name);
  }
}

// Cle d'une ligne dans son store (gere la PK composite de texts).
export function keyOf(category, row) {
  const keyPath = CONTENT_STORES[category];
  return Array.isArray(keyPath) ? keyPath.map((k) => row[k]) : row[keyPath];
}
